import React, { useState } from 'react';
import { speak } from '../app/speech';

const AudioButton = ({ word }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const playAudio = async (e) => {
        e.stopPropagation(); // prevent card flip
        if (isPlaying) return;
        setIsPlaying(true);

        try {
            // 1. Try Dictionary API
            const response = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${encodeURIComponent(word)}`);
            const data = await response.json();

            let audioUrl = null;
            if (Array.isArray(data) && data.length > 0) {
                // Find the first audio file
                for (const phonetics of data[0].phonetics) {
                    if (phonetics.audio) {
                        audioUrl = phonetics.audio;
                        break;
                    }
                }
            }

            if (audioUrl) {
                const audio = new Audio(audioUrl);
                audio.onended = () => setIsPlaying(false);
                audio.onerror = () => fallbackTTS(); // If format not supported
                await audio.play();
            } else {
                fallbackTTS();
            }
        } catch (err) {
            fallbackTTS();
        }
    };

    const fallbackTTS = () => {
        // 2. Fallback to text-to-speech, slightly slower
        speak(word, 0.8);

        // onend doesn't fire reliably in all browsers
        setTimeout(() => setIsPlaying(false), 2000);
    };

    return (
        <button
            type="button"
            className={`btn-sound ${isPlaying ? 'playing' : ''}`}
            onClick={playAudio}
            aria-label={`Listen to ${word}`}
        >
            {/* the .btn-sound background already draws the speaker icon */}
            <span style={{ fontSize: '12px' }}>{isPlaying ? 'Playing...' : 'Listen'}</span>
        </button>
    );
};

export default AudioButton;
